import axiosInstance from '../../../../../common/axios.service';
import type FILTERS from '../../../../../common/filters.type';

const stationGroupEmployeeList = (payload: {groupId: number; filters?: FILTERS}) => {
  return axiosInstance
    .get(`employeestation/${payload.groupId}`, {params: payload.filters})
    .then((response) => {
      return response;
    });
};
const updateStationGroupEmployee = (payload: {groupId: number; employee_ids: number[]}) => {
  return axiosInstance
    .put(`employeestation/${payload.groupId}`, {employee_ids: payload.employee_ids})
    .then((response) => {
      return response;
    });
};
const stationGroupEmployeesServices = {
  stationGroupEmployeeList,
  updateStationGroupEmployee,
};

export default stationGroupEmployeesServices;
